import { ReactNode, useState } from 'react';
import RightIcon from 'src/assets/icons/arrow-right-1.svg';
import DownIcon from 'src/assets/icons/arrow-down-1.svg';

type AccordionItem = {
  id: string;
  title: string;
  content: ReactNode;
};

export interface AccordionProps {
  items: AccordionItem[];
  defaultIndex?: number | null;
  className?: string;
}

const Accordion = ({
  items,
  defaultIndex = null,
  className,
}: AccordionProps) => {
  const [activeIndex, setActive] = useState<typeof defaultIndex>(defaultIndex);

  return (
    <div className={className}>
      {items.map((item, index) => {
        const isActive = index === activeIndex;
        const Icon = isActive ? DownIcon : RightIcon;

        return (
          <div
            className={`${index === 0 ? '' : 'border-t'} border-surface-ghost`}
            key={item.id}
          >
            <button
              type="button"
              id={`accordion-title-${item.id}`}
              className="flex w-full justify-between items-center py-4 gap-2 text-left"
              onClick={() =>
                setActive((prev) => (prev === index ? null : index))
              }
              aria-expanded={isActive}
              aria-controls={`accordion-text-${item.id}`}
            >
              <strong className="text-lg text-surface-alt-90 font-bold">
                {item.title}
              </strong>
              <Icon
                aria-hidden="true"
                className="text-lg text-surface-alt-75 flex-shrink-0"
              />
            </button>
            <div
              className="text-surface-alt-75 text-lg font-medium mt-2 mb-6 overflow-auto"
              id={`accordion-text-${item.id}`}
              role="region"
              aria-labelledby={`accordion-title-${item.id}`}
              hidden={!isActive}
            >
              {item.content}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
